import React, { useState, useEffect } from 'react';
import {
    Box,
    Divider,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    Modal,
    Paper,
    Grid2
} from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import { Add } from '@mui/icons-material';
import SingleFileUpload from '../../../fileUpload/FileUpload';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAwardDocuments, createAwardDocument, deleteAwardDocument } from '../../../../store/startup/documents/documentSlice';
import { useParams } from 'react-router-dom';
import { getFileLink } from '../../../../utils/getFileLink';

const AwardDocument = () => {
    const [open, setOpen] = useState(false);
    const [awardTitle, setAwardTitle] = useState('');
    const [description, setDescription] = useState('');
    const [awardingEntity, setAwardingEntity] = useState('');
    const [documentFilePath, setDocumentFilePath] = useState('');
    const [date, setDate] = useState('');
    const [errors, setErrors] = useState({
        awardTitle: false,
        description: false,
        awardingEntity: false,
        documentFilePath: false,
        date: false
    });
    const dispatch = useDispatch();
    const { startupId } = useParams();

    const { awardDocuments, loading } = useSelector(state => state.documents);

    useEffect(() => {
        dispatch(fetchAwardDocuments(startupId));
    }, [dispatch, startupId]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setAwardTitle('');
        setDescription('');
        setAwardingEntity('');
        setDocumentFilePath('');
        setDate('');
    };

    const handleSave = async () => {
        setErrors({
            awardTitle: false,
            description: false,
            awardingEntity: false,
            documentFilePath: false,
            date: false
        });

        const newErrors = {
            awardTitle: !awardTitle.trim(),
            description: !description.trim(),
            awardingEntity: !awardingEntity.trim(),
            documentFilePath: !documentFilePath.trim(),
            date: !date.trim()
        };

        if (Object.values(newErrors).some(error => error)) {
            setErrors(newErrors);
            return;
        }

        const documentData = {
            startupId,
            awardTitle,
            description,
            awardingEntity,
            documentFilePath: documentFilePath || "",
            date
        };

        try {
            await dispatch(createAwardDocument(documentData)).unwrap();
            await dispatch(fetchAwardDocuments(startupId));
            handleClose();
        } catch (error) {
            console.error('Failed to create award document:', error);
        }
    };

    const handleDelete = async (awardDocumentId) => {
        try {
            await dispatch(deleteAwardDocument(awardDocumentId)).unwrap();
        } catch (error) {
            console.error('Failed to delete award document:', error);
        }
    };

    const handleDocumentUpload = (filePath) => {
        setDocumentFilePath(filePath);
    }

    return (
        <div>
            <Box sx={{ display: 'flex', width: '100%' }}>
                <Box sx={{ flexGrow: 1, width: '80%' }}>
                    <Typography variant="h5" sx={{ mb: 2 }}>
                        Ödül ve Başarılar
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'right', justifyContent: 'right', width: '20%', height: '1%' }}>
                    <Button variant="outlined" size="small" color="primary" startIcon={<Add />} onClick={handleOpen}>
                        Yeni Ekle
                    </Button>
                </Box>
                <Divider sx={{ marginBottom: 3 }} />
            </Box>
            <Box>
                <TableContainer component={Paper} sx={{ marginBottom: 1 }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell> Ödülün Adı </TableCell>
                                <TableCell> Ödülü Verilen Kuruluş </TableCell>
                                <TableCell> Açıklama </TableCell>
                                <TableCell> Dosya </TableCell>
                                <TableCell>Ödülün Veriliş Tarihi</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {awardDocuments.map((startupAwardDocuments, index) => (
                                <TableRow key={index}>
                                    <TableCell>{startupAwardDocuments.awardTitle}</TableCell>
                                    <TableCell>{startupAwardDocuments.awardingEntity}</TableCell>
                                    <TableCell>{startupAwardDocuments.description}</TableCell>
                                    <TableCell>
                                        {startupAwardDocuments.documentFilePath !== "" ? (
                                            <a href={getFileLink(startupAwardDocuments.documentFilePath)} target="_blank" rel="noopener noreferrer">
                                                Döküman Linki
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                    </TableCell>
                                    <TableCell>{startupAwardDocuments.date}</TableCell>
                                    <TableCell align="right">
                                        <Button size='small' color="error" startIcon={<DeleteIcon />} onClick={() => handleDelete(startupAwardDocuments.awardDocumentId)}>
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>

            {/* Modal */}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 800,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                        borderRadius: 1,
                    }}
                >
                    <Typography id="modal-title" variant="h6" sx={{ mb: 2 }}>
                        Yeni Belge Ekle
                    </Typography>

                    <Grid2 container spacing={2}>
                        <Grid2 size={{ xs: 12, sm: 8 }}>
                            <TextField
                                label="Ödülün Adı"
                                fullWidth
                                sx={{ marginBottom: 2 }}
                                value={awardTitle}
                                onChange={(e) => setAwardTitle(e.target.value)}
                                error={errors.awardTitle}
                                helperText={errors.awardTitle ? "Ödülün adı boş bırakılamaz" : ""}
                            />
                            <TextField
                                label="Açıklama"
                                fullWidth
                                multiline
                                rows={4}
                                sx={{ marginBottom: 2 }}
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                error={errors.description}
                                helperText={errors.description ? "Açıklama boş bırakılamaz" : ""}
                            />
                            <TextField
                                label="Ödülü Veren Kuruluş"
                                fullWidth
                                sx={{ marginBottom: 2 }}
                                value={awardingEntity}
                                onChange={(e) => setAwardingEntity(e.target.value)}
                                error={errors.awardingEntity}
                                helperText={errors.awardingEntity ? "Ödülü veren kuruluş boş bırakılamaz" : ""}
                            />
                            <TextField
                                label="Ödülün Veriliş Tarihi"
                                fullWidth
                                sx={{ marginBottom: 2 }}
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                error={errors.date}
                                helperText={errors.date ? "Ödülün veriliş tarihi boş bırakılamaz" : ""}
                            />
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 4 }}>
                            <Box sx={{ width: '%100', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '90%' }} >
                                <SingleFileUpload onUploadComplete={handleDocumentUpload} existFilePath={documentFilePath} fileUploadPath={"startup"} />
                            </Box>
                        </Grid2>
                    </Grid2>

                    {errors.documentFilePath && (
                        <Typography color="error" variant="caption" sx={{ mt: 1 }}>
                            Lütfen bir dosya yükleyin
                        </Typography>
                    )}

                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button variant="outlined" color="error" onClick={handleClose}>
                            İptal
                        </Button>
                        <Button variant="contained" color="primary" onClick={handleSave}>
                            Kaydet
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Divider sx={{ marginBottom: 4, marginTop: 4 }} />
        </div>
    );
};

export default AwardDocument;
